module.exports = __webpack_public_path__ + "img/Zambia.5f244779.gif";